import styled from 'styled-components';

const StyledTimelineWrap = styled.div`
  position: relative;
  padding: 0 64px;
  background-color: #F5F1F1;
  padding: 160px 64px;
  overflow: hidden;
  margin-top: -${props => props.theme.components_spacing_desk.medium}px;
  margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  h4{
    padding-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  @media screen and (max-width: 1439px){
    padding: 160px 40px 125px;
    
    h4{
      padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
  }
  @media screen and (max-width: 1023px){
    padding: 128px 40px 128px;
    margin-top: -${props => props.theme.components_spacing_tablet.medium}px;
    margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;

  }
  @media screen and (max-width: 767px){
    padding: 80px 24px 80px;
    margin-top: -${props => props.theme.components_spacing_mobile.medium}px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;

    h4{
      padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
  }
`;

export {
  StyledTimelineWrap,
};

